/**
 * Extracts and validates the 'next' query parameter from a URL string.
 *
 * Validates that the next path is a relative path, and not an absolute URL or javascript code.
 * Returns the fallback value if 'next=' is missing, empty, or contains an unsafe value.
 *
 * @param url The full URL string to parse (must be a non-empty string)
 * @param fallback The value to return if 'next=' is missing, empty, or unsafe
 */
const getSafeNextPath = (
  url: string,
  fallback: string | null
): string | null => {
  const nextIndex = url.indexOf('next=');
  if (nextIndex === -1) return fallback;

  const decoded = decodeURIComponent(url.slice(nextIndex + 5));

  if (!decoded) return fallback;

  // Validate: must be a relative path, not an absolute URL or javascript:
  // - Must start with single forward slash
  // - Must not start with // (protocol-relative URL)
  // - Must not contain : before any / (blocks javascript:, http:, etc.)
  if (
    !decoded.startsWith('/') ||
    decoded.startsWith('//') ||
    /^[^/]*:/.test(decoded)
  ) {
    return fallback;
  }

  return decoded;
};

export default getSafeNextPath;
